

































































import Vue from 'vue';
import AuthService from '@/services/AuthService';
export default Vue.extend({
  data() {
    return {
      email: '',
      password: '',
      showPassword: false,
      authLoading: false,
    };
  },
  methods: {
    async login() {
      this.authLoading = true;
      try {
        await this.$store.dispatch('login', {email: this.email, password: this.password});
        await AuthService.afterLogin();
        this.authLoading = false;
        this.$router.push('/');
      } catch (error) {
        this.$store.commit('addSnackbar', {
          text: `Erro ao logar: ${error.message}`,
        });
        this.authLoading = false;
      }
    },
  },
});
